import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SlotsPropertiesApi from "../../services/api/Slots";
import ActionTypes from "./ActionTypes";
import SuccessMessages from "../../constants/SucessMessages.json";

const handleError = (err) => {
  console.log("[Slots] Error in Slots details", err);
};

export const setSlotsList = (payload) => {
  return {
    type: ActionTypes.SET_SLOTS_LIST,
    payload,
  };
};

export const setActiveSlot = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_SLOT,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_SLOTS,
    payload,
  };
};

export const resetStateSlot = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_SLOT,
    payload,
  };
};

export const getUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await SlotsPropertiesApi.getUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getBulkUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await SlotsPropertiesApi.getBulkUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverSlotsExemptionUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await SlotsPropertiesApi.getDriverSlotsExemptionUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getSlotsCancellationFeeExemptionUrl =
  (payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await SlotsPropertiesApi.getGigsCancellationFeeUrl(
        payload
      );
      dispatch(setLoader(false));
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverGigsCancellationFeeExemptionUrl =
  (payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await SlotsPropertiesApi.getDriverGigsCancellationFeeUrl(
        payload
      );
      dispatch(setLoader(false));
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverStarGigsExemptionUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await SlotsPropertiesApi.getDriverStarGigsExemptionUrl(
      payload
    );
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getGigsBulkOptInUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await SlotsPropertiesApi.getGigsBulkOptInUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getGigsBulkOptOutUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await SlotsPropertiesApi.getGigsBulkOptOutUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getSlotsList = (filters, removeCityId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const payload = { ...filters };
    if (removeCityId) {
      delete payload.city_id;
      delete payload.city;
    }
    let response = await SlotsPropertiesApi.getSlotsList(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.LIST_RETRIEVAL_SUCCESS,
        })
      );
      dispatch(setSlotsList(response));
      if (Object.keys(filters).length > 0) {
        dispatch(setActiveFilters(filters));
      } else if (Object.keys(filters).length === 0) {
        dispatch(resetStateSlot({ state: "activeFilters" }));
      }
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getActiveSlot = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await SlotsPropertiesApi.getActiveSlot(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveSlot(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
